/**
 * Enforce minimum order quantity on the cart page and cart drawer.
 */
(function () {
  const MIN_QTY = window.gradStolesCartConfig?.minOrderQty ?? 6;
  const PRODUCT_HANDLES = window.gradStolesCartConfig?.allowedHandles ?? ['stoles'];

  function showCartError(message) {
    const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (errors) errors.textContent = message;
  }

  function isStolesQuantityInput(input) {
    if (!(input instanceof HTMLInputElement)) return false;
    if (!input.matches('.cart-quantity .quantity__input')) return false;
    const handle = input.dataset.productHandle;
    return Boolean(handle && PRODUCT_HANDLES.includes(handle));
  }

  function previousQuantity(input) {
    const stored = parseInt(input.getAttribute('data-cart-quantity'), 10);
    if (!Number.isNaN(stored) && stored > 0) return stored;
    const value = parseInt(input.value, 10);
    if (!Number.isNaN(value) && value >= MIN_QTY) return value;
    return MIN_QTY;
  }

  function minQtyMessage() {
    return (
      window.gradStolesCartConfig?.minQtyError ??
      `Minimum order is ${MIN_QTY} stoles. Please update your quantity before checkout.`
    );
  }

  function clampQuantityInput(input) {
    const qty = parseInt(input.value, 10);
    if (Number.isNaN(qty) || qty === 0) return false;

    if (qty < MIN_QTY) {
      input.value = String(previousQuantity(input));
      showCartError(minQtyMessage());
      return true;
    }

    return false;
  }

  function onQuantityChange(event) {
    const input = event.target;
    if (!isStolesQuantityInput(input)) return;

    const qty = parseInt(input.value, 10);
    if (Number.isNaN(qty) || qty === 0) return;

    if (qty < MIN_QTY) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.value = String(previousQuantity(input));
      showCartError(minQtyMessage());
    }
  }

  function onQuantityInput(event) {
    const input = event.target;
    if (!isStolesQuantityInput(input)) return;
    clampQuantityInput(input);
  }

  function initCartQuantityInputs() {
    document.querySelectorAll('.cart-quantity .quantity__input[data-product-handle]').forEach((input) => {
      if (!isStolesQuantityInput(input)) return;
      input.min = String(MIN_QTY);
      input.setAttribute('data-min', String(MIN_QTY));
      clampQuantityInput(input);
    });
  }

  let listenersBound = false;

  function bindListenersOnce() {
    if (listenersBound) return;
    listenersBound = true;
    document.addEventListener('change', onQuantityChange, true);
    document.addEventListener('input', onQuantityInput, true);
    document.addEventListener('click', onMinusClick, true);
  }

  function onMinusClick(event) {
    const button = event.target.closest("button.quantity__button[name='minus']");
    if (!button) return;

    const input = button.closest('quantity-input')?.querySelector('.quantity__input');
    if (!isStolesQuantityInput(input)) return;

    const value = parseInt(input.value, 10);
    if (!Number.isNaN(value) && value <= MIN_QTY) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showCartError(minQtyMessage());
    }
  }

  function init() {
    bindListenersOnce();
    initCartQuantityInputs();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
